import script from "./CheckOutFlowCoursesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckOutFlowCoursesView.vue?vue&type=script&setup=true&lang=js"

import "./CheckOutFlowCoursesView.vue?vue&type=style&index=0&id=8064cd3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8064cd3a"]])

export default __exports__